package com.essntl.features.service.domain.use_case

import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.service.domain.repository.ServiceRepository
import org.koin.core.annotation.Single

@Single
class ExtraCategoryServiceUseCase(
    private val categoryRepository: CategoryRepository,
    private val serviceRepository: ServiceRepository,
) {
    private suspend fun getExtraCategory() =
        categoryRepository
            .getExtraCategory()
            .getOrNull()

    suspend fun getAllExtraServices(
        page: Long,
        limit: Int = 50,
        filterOptions: ServiceFilterOptions,
    ): Result<List<ServiceModel>> {
        val extraCategory = getExtraCategory() ?: return Result.success(emptyList())

        return serviceRepository.getAll(
            page = page,
            limit = limit,
            filterOptions = filterOptions.copy(selectedCategoryIds = setOf(extraCategory.id)),
        )
    }

    suspend fun getAllNonExtraServices(
        page: Long,
        limit: Int = 50,
        filterOptions: ServiceFilterOptions,
    ): Result<List<ServiceModel>> {
        val extraCategory = getExtraCategory()

        return serviceRepository.getAll(
            page = page,
            limit = limit,
            filterOptions = filterOptions.copy(excludeCategoryId = extraCategory?.id),
        )
    }

    suspend fun insertExtraCategoryService(
        service: ServiceModel,
    ): Result<ServiceModel> {
        val extraCategory = getExtraCategory() ?: return Result.failure(Exception("Extra category not found"))

        return serviceRepository.insert(service.copy(category = extraCategory.id))
    }
}